import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container } from '@mui/material';
import { Helmet } from '../lib/HelmetShim';
import ProductSection from '../components/ProductSection';
import { client } from '../api/Api';

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const Search = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const q = (query.get('q') || '').trim();

  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!q) {
      // If no query, go back to home
      navigate('/', { replace: true });
      return;
    }

    let cancelled = false;
    async function fetchResults() {
      setIsLoading(true);
      try {
        const res = await client.get('/search', { params: { q } });
        const items = res?.data?.products || [];
        if (!cancelled) setProducts(items);
      } catch (e) {
        if (!cancelled) setProducts([]);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    }
    fetchResults();
    return () => { cancelled = true; };
  }, [q, navigate]);

  return (
    <>
      <Helmet>
        <title>{q ? `Paieška: ${q} – Tikrai` : 'Paieška – Tikrai'}</title>
        <meta name="robots" content="noindex,follow" />
      </Helmet>
      <Container maxWidth="xl" className="container" sx={{ px: { xs: 1, sm: 2 } }}>
        <ProductSection
          products={products}
          isLoading={isLoading}
          isLoadingMore={false}
          hasMoreProducts={false}
          totalElements={products.length}
          loadMoreProducts={() => {}}
        />
      </Container>
    </>
  );
};

export default Search;
